export default __webpack_public_path__ + "static/media/yourtube-login.4bbcd862.png";